import { Alert } from './alertType';

export const SET_ALERT_INFO = '[ALERT_INFO] SET_ALERT_INFO';
export const REMOVE_ALERT = '[ALERT_INFO] REMOVE_ALERT';

export const setAlert = (payload: Alert) => ({
  type: SET_ALERT_INFO,
  payload,
});

export const removeAlert = (payload: number) => ({
  type: REMOVE_ALERT,
  payload,
});
